import { useState } from "react";

/**
 * Custom hook for managing hover state
 * @returns Object with isHovered state and event handlers
 */
export default function useHover() {
  const [isHovered, setIsHovered] = useState(false);

  const onMouseEnter = () => setIsHovered(true);
  const onMouseLeave = () => setIsHovered(false);

  return {
    isHovered,
    setIsHovered,
    onMouseEnter,
    onMouseLeave,
  };
}
